export default {"src":"/login-app/[GIT_HASH]/_next/static/media/run_canceled.a3443ea5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};